import { useTranslation } from 'react-i18next';

import FullSizeTile from '../../../shared/FullSizeTile';
import { useGetTile } from '../../../shared/TileView/data';
import { TileActionMenu } from '../../../shared/TileActionMenu/TileActionMenu.jsx';
import { useTileNavigation } from '../hooks/useTileNavigation';
import LoadingComponent from '../../../shared/LoadingComponent';

export const CampaignPreviewTileView = ({ tileId, campaignId }) => {
  const { data: tile, isLoading, isFetching } = useGetTile({
    tileId,
    preview: true,
    campaignUuid: campaignId,
  });
  const { t } = useTranslation('tileView');

  const {
    isFirstTile,
    isLastTile,
    goToEdit,
    goToPreview,
    goToNext,
    goToPrevious,
    goToRoot,
    arrowRightRef,
    arrowLeftRef,
  } = useTileNavigation({ tile, campaignId });

  const submitAnswer = () => {
    if (isLastTile) return;

    setTimeout(() => goToNext(), 1000);
  };

  if (isFetching) return <LoadingComponent />;

  return (
    <>
      <TileActionMenu
        currentPage="campaign-preview"
        uuid={tileId}
        onClose={goToRoot}
        onClick={() => goToEdit()}
        campaignId={campaignId}
        goToEdit={goToEdit}
        goToPreview={goToPreview}
        campaignContainer={tile.campaignContainer}
        tileStatus={tile.status}
        publishDate={tile.publishDate}
        postId={tile.postId}
      >
        {t('menu.edit')}
      </TileActionMenu>
      <FullSizeTile
        tile={tile}
        loading={isLoading}
        tileOrigin="campaign"
        submitAnswer={submitAnswer}
        nextTile={goToNext}
        prevTile={goToPrevious}
        isFirstTile={isFirstTile}
        isLastTile={isLastTile}
        arrowRightRef={arrowRightRef}
        arrowLeftRef={arrowLeftRef}
      />
    </>
  );
};
